import styled from 'styled-components';
import InputItem from './InputItem';
const MoneyInputItem = styled(InputItem) `
    position: relative;

    input {
        padding-left: 15px;
    }

    &:before {
        content: '€';
        position: absolute;
        top: 29px;
        left: 0;
        color: ${props => props.theme.primary.base};
        z-index: 1;
    }
`;
export default MoneyInputItem;
